import { ThunkAction } from 'redux-thunk'
import { Action } from 'redux'
import { Company } from '../../types/company/Company'
import { Store } from '../types'
import { RequestActionTypes } from '../middleware/types'
import { contextCompanyIdSelector } from './company/selectors'
import { BudgetingScenario } from '../../features/scenario/types/BudgetingScenario'
import { filtersSelector } from './filters/selectors'
import { PeriodGroup } from '../../types/periodGroup/PeriodGroup'
import { appLanguageSelector } from '../app/selectors'

/**
 * Simplified PeriodGroup for API requests (without periods array)
 */
export type ApiPeriodGroup = Omit<PeriodGroup, 'periods'>

export interface ContextRequestParams {
  companyId: Company['id']
  dimensions?: string
  budgetingScenarioId?: BudgetingScenario['id']
  data?: any
  periodGroups?: ApiPeriodGroup[]
}

export const contextRequest = (
  request: (params: ContextRequestParams, data?: any) => RequestActionTypes,
  data?: any
): ThunkAction<void, Store, null, Action<string>> => {
  return (dispatch, getState) => {
    const store: Store = getState()
    const companyId = contextCompanyIdSelector(store)!
    const lng = appLanguageSelector(store)
    const { budgetingScenario, periodGroups, dimensionsQuery } = filtersSelector(store)

    if (!companyId) return
    const contextParams = {
      companyId,
      periodGroups: periodGroups?.map(({ id, startDate, endDate, budgetable }) => ({
        id,
        startDate,
        endDate,
        budgetable
      })),
      lng,
      dimensions: dimensionsQuery,
      budgetingScenarioId: budgetingScenario && budgetingScenario.id
    }

    dispatch(request(contextParams, data))
  }
}
